import type { WootricConfig } from '../types/wootric';

let cachedWootricConfig: WootricConfig | null = null;

const defaultWootricConfig: WootricConfig = {
  wootricDomain: '',
  productionAccountId: '',
  testAccountId: '',
  product: '',
  productReportingCode: '',
  customerName: '',
  linkUrl: '',
  linkWord: '',
  blacklistedDomains: [],
};

export const configService = {
  async getWootricConfig(): Promise<WootricConfig> {
    if (cachedWootricConfig) {
      return cachedWootricConfig;
    }

    try {
      const response = await fetch('/config/wootric.config.json');
      if (!response.ok) {
        console.warn('Wootric config not found, using defaults');
        return defaultWootricConfig;
      }

      cachedWootricConfig = await response.json();
      return cachedWootricConfig!;
    } catch (error) {
      console.error('Failed to load Wootric config:', error);
      return defaultWootricConfig;
    }
  },

  clearCache(): void {
    cachedWootricConfig = null;
  },
};
